<template>


    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xl">

                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-edit-2-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                                <p class="cf-modal-head__sub">Formulaire</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <div class="cf-dialog-body">

                    <div class="box-body">
                        <div class="border-b-0 border-gray-200 dark:border-white/10">
                            <nav class="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400" aria-label="Tabs">

                                <button type="button" class="hs-tab-active:bg-white hs-tab-active:border-b-transparent
                                                hs-tab-active:text-primary dark:hs-tab-active:bg-transparent dark:hs-tab-active:border-b-white/10 dark:hs-tab-active:text-primary -mb-px py-2 px-3
                                                 inline-flex items-center gap-2 bg-gray-50 text-sm font-medium text-center border text-defaulttextcolor rounded-t-sm hover:text-primary
                                                 dark:bg-black/20 dark:border-white/10 dark:text-[#8c9097] dark:text-white/50 dark:hover:text-gray-300 active"
                                        id="hs-tab-js-behavior-item-1" data-hs-tab="#hs-tab-js-behavior-1" aria-controls="hs-tab-js-behavior-1">
                                    Information de base
                                </button>


                                <button type="button" class="hs-tab-active:bg-white hs-tab-active:border-b-transparent
                                                hs-tab-active:text-primary dark:hs-tab-active:bg-transparent dark:hs-tab-active:border-b-white/10 dark:hs-tab-active:text-primary -mb-px py-2 px-3
                                                 inline-flex items-center gap-2 bg-gray-50 text-sm font-medium text-center border text-defaulttextcolor rounded-t-sm hover:text-primary
                                                 dark:bg-black/20 dark:border-white/10 dark:text-[#8c9097] dark:text-white/50 dark:hover:text-gray-300"
                                        id="hs-tab-js-behavior-item-2" data-hs-tab="#hs-tab-js-behavior-2" aria-controls="hs-tab-js-behavior-2">
                                    Niveau d'accès
                                </button>



                            </nav>
                        </div>

                        <div class="">

                            <div v-if="messagesucces!==''" class="mt-4 mb-4 alert alert-success !border-success/10 flex items-center" role="alert">

                                <div v-html="messagesucces"></div>
                            </div>

                            <div v-if="messageerror!==''" class="mt-4 mb-4 alert alert-danger !border-danger/10 flex items-center" role="alert">

                                <div v-html="messageerror"></div>
                            </div>


                            <div id="hs-tab-js-behavior-1" role="tabpanel" aria-labelledby="hs-tab-js-behavior-item-1" class="">

                                <div class="ti-custom-validation mt-5" >
                                    <div class="grid lg:grid-cols-2 gap-6">

                                        <div class="space-y-2">
                                            <label class="ti-form-label dark:text-defaulttextcolor/70 mb-0">Caisse</label>
                                            <input v-model="Items.intitulecaisse" type="text" class="firstName my-auto ti-form-input  rounded-sm" placeholder="intitulé"   required>
                                            <span class="firstNameError text-red-500 text-xs hidden">error</span>
                                        </div>


                                        <div  class="space-y-2">
                                            <label class="ti-form-label dark:text-defaulttextcolor/70 mb-0">Type de caisse</label>
                                            <select v-model="Items.typedecaisse" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                                <option  value="0">Auxiliaire</option>
                                                <option value="1">Principale</option>
                                            </select>
                                        </div>


                                        <div  class="space-y-2">
                                            <label class="ti-form-label dark:text-defaulttextcolor/70 mb-0">Boutique 1</label>
                                            <select @change="changeboutique(1)" v-model="Items.boutique.btk1" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                                <option :value="null">Séléctionner un Dépôt/Magasin</option>
                                                <option v-for="(magasin,index) of alldata.magasin" :key="index" :value="magasin">{{magasin.name}}</option>
                                            </select>
                                        </div>


                                        <div  class="space-y-2">
                                            <label class="ti-form-label dark:text-defaulttextcolor/70 mb-0">Boutique 2</label>
                                            <select @change="changeboutique(2)" v-model="Items.boutique.btk2" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                                <option :value="null">Séléctionner un Dépôt/Magasin</option>
                                                <option v-for="(magasin,index) of boutique2" :key="index" :value="magasin">{{magasin.name}}</option>
                                            </select>
                                        </div>



                                        <!--div  class="space-y-2">
                                            <label class="ti-form-label dark:text-defaulttextcolor/70 mb-0">Boutique 3</label>
                                            <select @change="changeboutique(3)" v-model="Items.boutique.btk3" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                                <option :value="null">Séléctionner un Dépôt/Magasin</option>
                                                <option v-for="(magasin,index) of boutique3" :key="index" :value="magasin">{{magasin.name}}</option>
                                            </select>
                                        </div>



                                        <div  class="space-y-2">
                                            <label class="ti-form-label dark:text-defaulttextcolor/70 mb-0">Boutique 4</label>
                                            <select   v-model="Items.boutique.btk4" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                                <option :value="null">Séléctionner un Dépôt/Magasin</option>
                                                <option v-for="(magasin,index) of boutique4" :key="index" :value="magasin">{{magasin.name}}</option>
                                            </select>
                                        </div-->


                                    </div>




                                </div>
                            </div>

                            <div role="tabpanel" class="hidden" id="hs-tab-js-behavior-2"
                                 aria-labelledby="hs-tab-js-behavior-item-2" >

                                <table class="table table-striped table-bordered
                                table-hover dataTable no-footer dtr-inline mytable w-full">

                                    <thead>
                                    <tr>
                                        <th>Module</th>
                                        <th>Action</th>

                                    </tr>
                                    </thead>

                                    <tbody>
                                    <template v-if="dataniveaudacces.length">



                                        <tr style="font-weight: 600;/*background: khaki;*/"
                                            v-for="(datavalue,index) in dataniveaudacces" :key="index">

                                            <td  data-label="Module  : " ><strong style="font-size: 15px;">{{ datavalue.libelle }}</strong></td>
                                            <td  data-label="Action  : " >




                                                <select v-if="datavalue.name!=='pagefacturationcaisse'"
                                                        @change="changeaccesclick(datavalue)"
                                                        class="form-control w-full" >

                                                    <template  v-if="datavalue.acces===0">
                                                        <option selected value="0">Interdire</option>
                                                        <option value="1">Autoriser</option>
                                                    </template>
                                                    <template v-else>
                                                        <option  value="0">Interdire</option>
                                                        <option selected value="1">Autoriser</option>
                                                    </template>

                                                </select>


                                                <template v-else>



                                                    <div class="xl:col-span-6 col-span-12 mb-3">
                                                        <label >Affichage</label>
                                                        <select v-model="datavalue.acces" class="form-control" >
                                                            <option :selected="parseFloat(datavalue.acces)===0" :value="0">Interface de facturation (boutique).</option>
                                                            <option  :selected="parseFloat(datavalue.acces)===1" :value="1">Interface de facturation pour des établissements tels que les restaurants et les festivals.</option>
                                                            <option  :selected="parseFloat(datavalue.acces)===6" :value="6">Interface de facturation, Caisse Enregistreuse.</option>
                                                            <option :selected="parseFloat(datavalue.acces)===5" :value="5">Interface par défaut.</option>
                                                        </select>
                                                    </div>
                                                    <!--div class="xl:col-span-6 col-span-12 ">
                                                        <a :href="urletatpicture" target="_blank">
                                                            <img  class="img-responsive imgsize" :src="urletatpicture" alt="">
                                                        </a>
                                                    </div-->


                                                </template>




                                            </td>

                                        </tr>


                                    </template>



                                    <template v-else>
                                        <tr >
                                            <td colspan="4"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                        </tr>

                                    </template>




                                    </tbody>








                                </table>

                            </div>


                        </div>
                    </div>




                </div>
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full" >
                        Fermer
                    </button>
                    <button v-if="typeaction==='add'"  class="ti-btn ti-btn-primary-full" @click="saveItems">
                       Enregistrer
                    </button>
                    <button v-if="typeaction==='update'" class="ti-btn ti-btn-primary-full" @click="updateItems">
                       Modifier
                    </button>
                </div>
            </div>
            </Transition>
        </div>
    </Transition>



</template>

<script>
    import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import appmenu from "@/components/views/pages/definition/menu";
   // import allfunction from "@/allfunction";
    import {randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "modalform",
        watch: {


        },

        computed:{

            disabled:function () {

                if (this.Items.usecaisse===0){
                    return false
                }

                if (this.Items.usecaisse===1){
                    return true
                }

            },


            boutique2(){
                let mvalue=[];


                if (this.Items.boutique.btk1!==null){

                    mvalue = this.alldata.magasin.filter(m => m.pid !== this.Items.boutique.btk1.pid)

                }


                return mvalue;
            },

            boutique3(){
                let mvalue=[];
                // this.caisse.boutique.btk2=null;
                /* this.caisse.boutique.btk3=null;
                 this.caisse.boutique.btk4=null;
 */
                if (this.Items.boutique.btk2!==null){

                    mvalue = this.boutique2.filter(m => m.pid !== this.Items.boutique.btk2.pid)

                }


                return mvalue;
            },

            boutique4(){
                let mvalue=[];
                // this.caisse.boutique.btk2=null;
                // this.caisse.boutique.btk3=null;
                // this.caisse.boutique.btk4=null;

                if (this.Items.boutique.btk3!==null){

                    mvalue = this.boutique3.filter(m => m.pid !== this.Items.boutique.btk3.pid)

                }


                return mvalue;
            },





        },
        components: {
            templatesite,
            appheader,
            appsidebar,
            appmenu,

        },

        data() {
            return {
                isdisplay:false,
                messageerror:"",
                messagesucces:"",
                titlemodal:"",
                typedoc:"",
                typeaction:"add",
                alldata:[],
                dataniveaudacces:[],
                datanewniveaudacces:[],
                nbremg:false,
                Items: {},
            };
        },
        methods: {


            changeaccesclick(value){

                if (value.acces===0){
                    value.acces=1
                }else{
                    value.acces=0
                }

            },



            changeboutique(p) {

                if (p===1){
                    this.Items.boutique.btk2=null;
                    this.Items.boutique.btk3=null;
                    this.Items.boutique.btk4=null;
                }


                if (p===2){
                    //this.caisse.boutique.btk2=null;
                    this.Items.boutique.btk3=null;
                    this.Items.boutique.btk4=null;
                }

                if (p===3){
                    //this.caisse.boutique.btk2=null;
                    // this.caisse.boutique.btk3=null;
                    this.Items.boutique.btk4=null;
                }



            },





            close(){

                this.isdisplay=false;

                this.$emit('closed');

            },

            show(titlemodal,typeaction,Items,niveaudacces,alldata ){

                this.titlemodal=titlemodal
                this.typeaction=typeaction
                this.Items=Items
                this.messagesucces="";
                this.messageerror="";
                this.alldata=alldata
                this.dataniveaudacces=niveaudacces
                this.datanewniveaudacces=niveaudacces

                this.isdisplay=true;

            },

              async  saveItems(){

                    this.$store.dispatch('lancerchargement',true)

                    if (this.Items.intitulecaisse==="" ){

                        toastr['error']( 'Veuillez saisir toutes les informations',"<b></b>");
                        this.$store.dispatch('lancerchargement',false)
                        return

                    }

                  this.Items.niveaudacces=this.dataniveaudacces;
                  const t = this;
                  let url=process.env.VUE_APP_API_URL+'/egl7admincaissee771714dfe/caisse/'+this.$store.state.appsociete+'/89541savecaisse519151911515/'+randomString(200);
                  let response =   axios  .post(url,this.Items,{
                      headers: {
                          'X-Requested-With': 'XMLHttpRequest',
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                          'Authorization': 'Bearer ' + JwtService.getToken(),
                          'csrftoken': this.$store.state.appsociete
                      } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                  })

                  let res= await response
                        .then(function (res){
                           // t.$store.dispatch('beartoken',res.data.beartoken)
                            t.$store.dispatch('lancerchargement',false)
                            if(res.data.success){

                                t.messagesucces="";
                                t.messageerror="";

                                t.Items= {
                                    pid:'',
                                    beartoken:'',
                                    codecaisse:'',
                                    intitulecaisse:'',
                                    typedecaisse:0,
                                    numerodecomptecomptable:'',
                                    comptecomptable:null,
                                    boutique:{
                                        btk1:null,
                                        btk2:null,
                                        btk3:null,
                                        btk4:null
                                    },
                                    params:{
                                        param1:null,
                                        param2:null,
                                        param3:null,
                                        param4:null,
                                    },
                                    caisse:{usecaisse:0},
                                    niveaudacces:t.datanewniveaudacces
                                };

                                t.dataniveaudacces=t.datanewniveaudacces

                                t.messagesucces=res.data.message;

                                toastr['success']( t.messagesucces,"<b></b>");

                            }
                           else{

                               let errormessage="";

                                t.messageerror="";
                                t.messagesucces="";
                                if (res.data.datamessage.length>0){

                                    for (let message of res.data.datamessage){

                                        if (errormessage===""){

                                            errormessage=message;

                                        }else{

                                            errormessage+=" , "+message;

                                        }


                                    }


                                    t.messageerror=errormessage;

                                }
                                else{
                                    t.messageerror=res.data.message
                                }


                                toastr['error'](t.messageerror,"<b></b>");
                            }


                        })
                        .catch(

                            error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                                "<b>Erreur</b>")
                        )
                        .finally(() => this.$store.dispatch('lancerchargement',false))


                },


              async  updateItems(){

                    this.$store.dispatch('lancerchargement',true)



                  if (this.Items.intitulecaisse==="" ){

                      toastr['error']( 'Veuillez saisir toutes les informations',"<b></b>");
                      this.$store.dispatch('lancerchargement',false)
                      return

                  }

                  this.Items.niveaudacces=this.dataniveaudacces;
                  const t = this;
                  let url=process.env.VUE_APP_API_URL+'/egl7admincaissee771714dfe/caisse/'+this.$store.state.appsociete+'/89541updatecaisse519151911515/'+randomString(200);
                  let response =   axios  .post(url,this.Items,{
                      headers: {
                          'X-Requested-With': 'XMLHttpRequest',
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                          'Authorization': 'Bearer ' + JwtService.getToken(),
                          'csrftoken': this.$store.state.appsociete
                      } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                  })


                  let res= await response
                        .then(function (res){
                           // t.$store.dispatch('beartoken',res.data.beartoken)
                            t.$store.dispatch('lancerchargement',false)
                            if(res.data.success){

                                t.messagesucces="";
                                t.messageerror="";

                                t.messagesucces=res.data.message;

                                toastr['success']( t.messagesucces,"<b></b>");


                                t.close()

                            }
                            else{

                               let errormessage="";

                                t.messageerror="";
                                t.messagesucces="";
                                if (res.data.datamessage.length>0){

                                    for (let message of res.data.datamessage){

                                        if (errormessage===""){

                                            errormessage=message;

                                        }else{

                                            errormessage+=" , "+message;

                                        }


                                    }


                                    t.messageerror=errormessage;

                                }
                                else{
                                    t.messageerror=res.data.message
                                }


                                toastr['error'](t.messageerror,"<b></b>");
                            }


                        })
                        .catch(

                            error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                                "<b>Erreur</b>")
                        )
                        .finally(() => this.$store.dispatch('lancerchargement',false))


                },


        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xl { max-width:900px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-th { background:var(--cf-surface-alt)!important; color:var(--cf-ink)!important; font-weight:600; font-size:0.75rem; letter-spacing:0.02em; }
.cf-actions { display:inline-flex; align-items:center; gap:4px; }
.cf-iconbtn { height:2rem; width:2rem; display:inline-flex; align-items:center; justify-content:center; border:none; border-radius:var(--cf-radius-sm); cursor:pointer; font-size:1rem; transition:all 0.15s; background:var(--cf-surface-alt); color:var(--cf-muted); }
.cf-iconbtn--primary:hover { background:rgb(var(--primary) / 0.12); color:rgb(var(--primary)); }
.cf-iconbtn--danger:hover { background:rgb(var(--danger) / 0.12); color:rgb(var(--danger)); }
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }
@media (max-width:768px) { .cf-dialog--xl { max-width:100%; } }
</style>